import React from 'react';

const IntegrationsSyncContext = React.createContext();

export default IntegrationsSyncContext;
